import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';
import updateStorecreatorData from '../_update_storecreator_data';
import pathNames from './_path_names';
import categoryList from './_category_list';
import modalDeleteCategoryConfirm from './_modal_delete_category_confirm';


/**
 * カテゴリ管理コンポーネント
 */
export default {
    name: 'category',
    template: '#modal_category_edit_template',
    data() {
        return {
            // 全カテゴリ配列
            categories: [],
            // チェック中のパスリスト
            edit_path_config: [],
            // 現在の開いている子カテゴリリスト [{page_key:, parent_page_key:}]
            show_childs: [],
        };
    },
    props: {
        // ディスプレイモード
        displayMode: {
            type: String,
            default: 'normal',
            validator: function (value) {
                // プロパティの値は、必ずいずれかの文字列でなければならない
                return ['normal', 'link'].indexOf(value) !== -1;
            }
        },
        // page_keyの配列
        pathConfig: {
            type: Array,
            default: () => ([])
        },
    },
    computed: {
        // スロットが未使用か
        isEmptySlot: function () {
            return isSlotEmpty(this.$slots);
        },
        // カテゴリが一つもないか
        isEmptyCategories: function () {
            return (this.categories.length === 0);
        },
        // パスが選択されているか
        hasPathConfig: function () {
            return (this.edit_path_config.length > 0);
        },
    },
    components: {
        // ストアクリエイターからデータを取得するコンポーネント
        'update-storecreator-data': updateStorecreatorData,
        // pathの日本語名を表示するコンポーネント
        'path-names': pathNames,
        // カテゴリリストを表示するコンポーネント
        'category-list': categoryList,
        // カテゴリ削除確認モーダル
        'modal-delete-category-confirm' : modalDeleteCategoryConfirm,
    },
    mixins: [
        modalMixin,
        flashMessageMixin
    ],
    emits: [
        'update:pathConfig',
        'selected-category',
    ],
    methods: {
        // ディスプレイモードが通常か
        isDisplayModeNormal: function () {
            return this.displayMode === 'normal';
        },
        // パス選択＆カテゴリ編集画面を開く
        show: function () {
            this.edit_path_config = this.pathConfig;
            this.iniShowChilds();
            this.open();
        },
        // 選択されているパスのツリーを展開
        iniShowChilds: function() {
            // 一旦空にする
            this.show_childs = [];
            // 指定されているpath_configからpage_keyとparent_page_keyを取得
            for (let i in this.pathConfig) {
                this.pushShowChilds(this.pathConfig[i], true);
            }
        },
        // 指定parent_page_keyのカテゴリを返す
        pushShowChilds: function (pageKey, end = false) {
            const category = this.categories.find(category => category.page_key === pageKey);
            if (typeof category === 'undefined') {
                return;
            }
            // 指定path自身(末端)は追加しない
            if (!end) {
                this.show_childs.push({
                    page_key: category.page_key,
                    parent_page_key: category.parent_page_key,
                });
            }
            if (category.parent_page_key !== null) {
                this.pushShowChilds(category.parent_page_key);
            }
        },
        // パス選択を更新して閉じる
        updatePathConfig: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.close();
            this.emitUpdatePathConfig();
        },
        // パス更新通知
        emitUpdatePathConfig: function () {
            this.$emit('update:pathConfig', this.edit_path_config);
        },
        // カテゴリ選択を通知する
        emitSeletedCategory: function (categoryData) {
            if(this.isDisplayModeNormal()) {
                // 通常モードの時利用動作させない
                return;
            }
            this.close();
            this.$emit('selected-category', categoryData);
        },
        // カテゴリ削除確認モーダルを開く
        openModalDeleteCategoryConfirm: function (params) {
            this.$refs.deleteCategoryConfirm.openModal(params);
        },
        // -------------------------
        // $refsから実行想定メソッド(新規カテゴリ登録ページ用)
        // -------------------------

        // 指定カテゴリを削除する
        deleteCategory: function(deletedPageKey) {
            let categories = _.cloneDeep(this.categories);
            let deletedCategory = null;
            // カテゴリリストから削除
            for (const i in categories) {
                if (categories[i].page_key === deletedPageKey) {
                    deletedCategory = categories[i];
                    categories.splice(i, 1);
                    break;
                }
            }
            // orderを振り直す
            if (deletedCategory) {
                for (const i in categories) {
                    // 削除した同parentKey以外はスキップ
                    if (categories[i].parent_page_key !== deletedCategory.parent_page_key) {
                        continue;
                    }
                    // 削除したorder番号以下はスキップ
                    if (categories[i].order < deletedCategory.order) {
                        continue;
                    }
                    let category = categories[i];
                    category.order = category.order - 1;
                    categories[i] = category;
                }
            }
            this.categories = categories;
            // チェック済みの場合、チェック中リストから削除する
            this.edit_path_config = this.edit_path_config.filter(function(pageKey) {
                return pageKey !== deletedPageKey;
            });
            this.emitUpdatePathConfig();
        },
        // カテゴリ一覧データをセットする
        setCategories: function (categories) {
            if (Object.keys(categories).length) {
                this.categories = _.cloneDeep(categories);
            }
        },
        // カテゴリ一覧データを取得する
        getCategories: function () {
            return _.cloneDeep(this.categories);
        },
    }
};
